import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLinkedin,
  faInstagram,
  faGithub,
} from "@fortawesome/free-brands-svg-icons";

// helper function to get the year for the copy right
function getCurrentYear() {
  return new Date().getFullYear();
}

function Footer() {
  return (
    <footer className="sticky-bottom p-5">
      <hr />
      <div className="container">
        <div className="row">
          <div className="col-md-3">
            <h6>Phone</h6>
            <a href="tel:+17204703778" className="text-dark">
              720-470-3778
            </a>
          </div>
          <div className="col-md-3">
            <h6>Email</h6>
            <a href="mailto:awilliams7529@gmail.com" className="text-dark">
              awilliams7529@gmail.com
            </a>
          </div>
          <div className="col-md-3">
            <h6>Let's Connect</h6>
            <div>
              <a
                href="https://www.linkedin.com/in/chillyssa"
                className="text-dark me-3"
              >
                <FontAwesomeIcon icon={faLinkedin} size="2x" />
              </a>
              <a
                href="https://www.instagram.com/chillyssa"
                className="text-dark me-3"
              >
                <FontAwesomeIcon icon={faInstagram} size="2x" />
              </a>
              <a href="https://github.com/chillyssa" className="text-dark">
                <FontAwesomeIcon icon={faGithub} size="2x" />
              </a>
            </div>
          </div>
          <div className="col-md-3">
            <p>© {getCurrentYear()} By Alyssa Williams</p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
